(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["combina-com"] && !Shopify.designMode) return;
  try {
    (function() {
    const carousel = document.querySelector('.combina-com-products');
    if (!carousel) return;

    let isDown = false;
    let startX;
    let startScrollLeft;

    function handleMouseDown(e) {
      if (e.target.closest('.combina-com-button')) {
        return;
      }
      
      isDown = true;
      carousel.classList.add('dragging');
      startX = e.pageX;
      startScrollLeft = carousel.scrollLeft;
      carousel.style.cursor = 'grabbing';
      e.preventDefault();
    }

    function handleMouseMove(e) {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX;
      const walk = (x - startX) * 2;
      carousel.scrollLeft = startScrollLeft - walk;
    }

    function handleMouseUp() {
      isDown = false;
      carousel.classList.remove('dragging');
      carousel.style.cursor = 'grab';
    }

    carousel.addEventListener('mousedown', handleMouseDown);
    carousel.addEventListener('mouseleave', handleMouseUp);
    carousel.addEventListener('mouseup', handleMouseUp);
    carousel.addEventListener('mousemove', handleMouseMove);

    const items = carousel.querySelectorAll('.combina-com-item');
    items.forEach(function(item) {
      item.addEventListener('mousedown', handleMouseDown);
    });

    carousel.style.cursor = 'grab';
  })();

  (function() {
    async function addToCart(variantId) {
      const formData = {
        items: [{
          id: variantId,
          quantity: 1
        }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      };

      const rootUrl = window.Shopify?.routes?.root || '/';
      const response = await fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.description || 'Erro ao adicionar ao carrinho');
      }

      return await response.json();
    }

    function updateCartDrawer(sections) {
      const cartDrawer = document.querySelector('cart-drawer');
      
      if (cartDrawer && sections) {
        const parsedState = {
          sections: sections
        };
        
        if (typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(parsedState);
        } else {
          const cartDrawerSection = sections['cart-drawer'];
          if (cartDrawerSection) {
            const cartDrawerElement = document.getElementById('CartDrawer');
            if (cartDrawerElement) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(cartDrawerSection, 'text/html');
              const newContent = doc.querySelector('#CartDrawer');
              if (newContent) {
                cartDrawerElement.innerHTML = newContent.innerHTML;
              }
            }
          }
          
          const cartIconSection = sections['cart-icon-bubble'];
          if (cartIconSection) {
            const cartIconElement = document.getElementById('cart-icon-bubble');
            if (cartIconElement) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(cartIconSection, 'text/html');
              const newContent = doc.querySelector('.shopify-section');
              if (newContent) {
                cartIconElement.innerHTML = newContent.innerHTML;
              }
            }
          }
          
          cartDrawer.classList.add('animate', 'active');
          document.body.classList.add('overflow-hidden');
        }
      }
    }
    
    function handleButtonClick(e) {
      const button = e.target.closest('.combina-com-button');
      if (!button) return;
      
      e.preventDefault();
      e.stopPropagation();
      
      const variantId = button.getAttribute('data-variant-id');
      if (!variantId) {
        console.error('Combina Com: Variant ID não encontrado');
        return;
      }

      if (button.classList.contains('loading') || button.classList.contains('success')) {
        return;
      }

      button.classList.remove('in-cart', 'success');
      button.classList.add('loading');
      button.disabled = true;
      
      addToCart(parseInt(variantId))
        .then(function(response) {
          button.classList.remove('loading');
          button.classList.add('success');
          
          if (response.sections) {
            updateCartDrawer(response.sections);
          }

          setTimeout(function() {
            button.classList.remove('success');
            button.classList.add('in-cart');
            button.disabled = false;
          }, 1500);
        })
        .catch(function(error) {
          console.error('Combina Com: Erro ao adicionar:', error);
          button.classList.remove('loading', 'success');
          button.disabled = false;
        });
    }
    
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.addEventListener('click', handleButtonClick);
    }
    
    document.addEventListener('click', function(e) {
      if (e.target.closest('.combina-com-button')) {
        handleButtonClick(e);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
